<div #script>
  <ng-content></ng-content>
</div>
